export const IMAGE_EXTENSION = {
  SVG: 'svg',
  PNG: 'png',
};

export const BRANCH_DEFAULT_ZOOM = 14;
